<form *ngIf="form" [formGroup]="form" class="p-3 border rounded">
    <div class="row">
        <div class="col-md-4 col-lg-3 col-xs-12">
            <app-select [formControl]="form.get('paymentTypeClient')" [config]="formConfiguration.paymentTypeClient">
            </app-select>
        </div>
        <div class="col-md-4 col-lg-3 col-xs-12">
            <app-select [formControl]="form.get('clientPartnersId')" [config]="formConfiguration.clientPartnersId">
            </app-select>
        </div>
        <div class="col-md-4 col-lg-3 col-xs-12">
            <app-select [formControl]="form.get('paymentClientUid')" [config]="formConfiguration.paymentClientUid">
            </app-select>
        </div>
        <div class="col-md-4 col-lg-3 col-xs-12">
            <app-select [formControl]="form.get('clientEfectivoId')" [config]="formConfiguration.clientEfectivoId">
            </app-select>
        </div>
        <div class="col-md-4 col-lg-3 col-xs-12">
            <app-select [formControl]="form.get('entranceAccount')" [config]="formConfiguration.entranceAccount">
            </app-select>
        </div>
        <div class="col-md-4 col-lg-3 col-xs-12">
            <app-input [formControl]="form.get('accountNumberClient')"
                [config]="formConfiguration.accountNumberClient"></app-input>
        </div>
    </div>
    <div class="row">
        <div class="col-md-4 col-lg-3 col-xs-12">
            <app-select [formControl]="form.get('taxClientUid')" [config]="formConfiguration.taxClientUid">
            </app-select>
        </div>
        <div class="col-md-4 col-lg-3 col-xs-12">
            <app-select [formControl]="form.get('taxClientSecondUid')" [config]="formConfiguration.taxClientSecondUid">
            </app-select>
        </div>
    </div>
    <div class="row">
        <div class="col-md-4 col-lg-3 col-xs-12">
            <app-select [formControl]="form.get('employeeId')" [config]="formConfiguration.employeeId">
            </app-select>
        </div>
        <div class="col-md-4 col-lg-3 col-xs-12">
            <app-input [formControl]="form.get('assignedCode')" [config]="formConfiguration.assignedCode"></app-input>
        </div>
        <div class="col-md-4 col-lg-3 col-xs-12">
            <app-input [formControl]="form.get('expirationClient')"
                [config]="formConfiguration.expirationClient"></app-input>
        </div>
    </div>
</form>